//  For each product on the page
document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    /************
     Product Swipers
     ************/
    section.querySelectorAll('.productVisualWrap').forEach(item => {
        let productSwiper = new Swiper(item.querySelector(".productVisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: item.querySelector(".productVisualSwiperNext"),
                prevEl: item.querySelector(".productVisualSwiperPrev"),
            },
            on: {
                slideChange: function () {
                    if (!item.querySelector(".productVisualSwiperSlide")) {
                        return;
                    }
                    // update the thumbnail active class
                    item.querySelector(".productVisualThumbsSlide.active").classList.remove("active");
                    item.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");

                }
            }
        });

        // change slide on thumbnail click
        item.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
            element.addEventListener("click", function () {
                // change slide
                productSwiper.slideTo(this.dataset.index - 1);
            });
        });

    })


    // update active variant on input changes
    section.querySelectorAll(".product input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/
    async function updateProduct() {

        // variables to check if elements exist
        let productATCExists = section.querySelector(".productATC") || false;

        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productOptionItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATC").textContent = "Not Available";

            section.querySelector('.productGiftFormSubmit').classList.add('disabled');
            section.querySelector('.productGiftFormSubmit').textContent = 'Not Available';

            return;
        }

        /**************
         Active Swiper
         ***************/
        let color = 'black'
        if (activeVariant.option1.includes('White')) {
            color = 'white';
        }
        section.querySelectorAll('.productVisualWrap').forEach(item => {
            if (item.classList.contains(color)) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        })

        // color label
        section.querySelector('.productOptionItemControlsTitleColor').textContent = activeVariant.option1;


        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").disabled = false;
            // check if there is a price override attribute
            const priceOverride = section.querySelector('.productATC').dataset.priceOverride;
            if (priceOverride) {
                section.querySelector(".productATC").textContent = `Add To Cart - ${priceOverride}`;
            } else {
                section.querySelector(".productATC").textContent = `Add To Cart - ` + price(activeVariant.price, true);
            }
            section.querySelector('.productGiftFormSubmit').classList.remove('disabled');
            section.querySelector('.productGiftFormSubmit').textContent = 'SUBMIT';

        } else {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATC").textContent = "Sold Out";
            section.querySelector('.productGiftFormSubmit').classList.add('disabled');
            section.querySelector('.productGiftFormSubmit').textContent = 'Sold Out';

        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image on page load
    updateProduct();


    /**************
     Product Sizes
     ***************/
    // listen for size button click
    document.querySelectorAll('.productOptionItemControlsCountriesItem').forEach(element => {
        element.addEventListener("click", function () {
            // remove active class from all buttons
            document.querySelectorAll('.productOptionItemControlsCountriesItem').forEach(item => {
                item.classList.remove("active");
            });
            element.classList.add("active");


            // show the selected size
            let target = element.dataset.target;
            document.querySelectorAll(`.productOptionItemValuesLabelBodySizes`).forEach(item => {
                item.classList.remove("active");
                if (item.classList.contains(target)) {
                    item.classList.add("active");
                }
            });


        });

    });

    /**************
     Product ATC
     ***************/
    section.querySelector('.productATC').addEventListener("click", async function () {

        // add loading animation
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open upsell
        await openUpsell();

        // open cart
        await openCart();
    });


    // Submit gift form
    section.querySelector('.productGiftFormSubmit').addEventListener('click', async function (e) {
        e.preventDefault();

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // create url params
        const giftParams = new URLSearchParams({
            fromName: document.querySelector(".productGiftFormName").value,
            handle: product.handle,
            formData: JSON.stringify(formData)
        }).toString();

        // send event to Klaviyo
        const response = await fetch(`https://api.vktry.com/send-a-gift.php`, {
            method: "POST",
            body: new URLSearchParams({
                fromName: document.querySelector(".productGiftFormName").value,
                toEmail: document.querySelector(".productGiftFormEmail").value,
                purchaseURL: `https://${window.location.hostname}/pages/send-gift-clogs?${giftParams}`,
            })
        })
            .then(response => response.json())

        // check for error
        if (response.error) {
            await Swal.fire({
                title: 'Error',
                text: response.error,
            });
            return;
        }

        // update text
        section.querySelector(".productGiftTxt").textContent = "Your email was sent with the VKTRYs you would like as a gift.";
        section.querySelector('.productGiftForm').classList.remove('active');
    });


    // setup Dropdowns
    section.querySelectorAll(".productInfoDropTop").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    // get reviews count
    fetch(`https://api.okendo.io/v1/stores/a23ff890-5779-4aad-a3bc-dd0fdde26942/products/shopify-14619269136751/review_aggregate`)
        .then(response => response.json())
        .then(data => {
            // calculate average rating
            const totalReviews = data.reviewAggregate.ratingAndReviewCount;

            // insert average rating
            //AR=1∗a+2∗b+3∗c+4∗d+5∗e/(R)
            //where a,b,c,d,e are the number of reviews with rating 1,2,3,4,5 respectively and R is the total number of reviews
            let level1Count = data.reviewAggregate.ratingAndReviewCountByLevel.level1Count || 0;
            let level2Count = data.reviewAggregate.ratingAndReviewCountByLevel.level2Count || 0;
            let level3Count = data.reviewAggregate.ratingAndReviewCountByLevel.level3Count || 0;
            let level4Count = data.reviewAggregate.ratingAndReviewCountByLevel.level4Count || 0;
            let level5Count = data.reviewAggregate.ratingAndReviewCountByLevel.level5Count || 0;

            const averageRating = (1 * level1Count + 2 * level2Count + 3 * level3Count + 4 * level4Count + 5 * level5Count) / totalReviews;
            const averageRatingRounded = Math.round(averageRating * 10) / 10;


            // update label
            section.querySelectorAll(".productFormReviewsTxtLink").forEach(element => {
                element.textContent = `${totalReviews}+ reviews`;
            });

            section.querySelectorAll(".productFormReviewsTxtAvg").forEach(element => {
                element.textContent = `${averageRatingRounded}`;
            });

        })
});


/**************
 Product Upsells
 ***************/

// upsell swiper
let upsellSwiper = new Swiper('.upsellSwiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
        el: '.upsellSwiperFooterPag',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
    },
});

// store the swiper slides to use for later
let socksSlide = document.querySelector('#upsellSocks');
let boostsSlide = document.querySelector('#upsellBoosts');
let gripsSlide = document.querySelector('#upsellGrips');
let clogsSlide = document.querySelector('#upsellClogs');
let silverSlide = document.querySelector('#upsellSilver');
let bagSlide = document.querySelector('#upsellBag');
let silverProduct = JSON.parse(document.querySelector('#upsellSilver').dataset.product)


// add to cart event listeners
document.querySelectorAll(".upsellCheckout").forEach(element => {
    element.addEventListener("click", async function () {

        // Used in Discount Kit to target specific upsell products
        let discountProperty = '';

        // start loading
        this.classList.add("loading");

        // determine the first insole gender and size
        const gender = document.querySelector('.productOptionItemValuesLabelInput.gender:checked').value;
        const size = document.querySelector('.productOptionItemValuesLabelInput.size:checked').value;

        // determine the variant id
        let variantID;
        let available = true;

        if (element.classList.contains("boosts")) {
            discountProperty = 'boosts_upsell';
            if ((gender === "Male" && isSizeInRange(size, 0, 9)) || (gender === "Female" && isSizeInRange(size, 0, 10.5))) {
                variantID = 42757218402475; // medium
            } else {
                variantID = 42757218435243; // large
            }
        } else if (element.classList.contains("silver")) {
            discountProperty = 'silver_upsell';

            // find the silver variant based on the selected input from silver and clogs
            let silverWeight = document.querySelector('#upsellSilver').querySelector('.upsellLabelInput:checked').value;
            let variant = silverProduct.variants.filter(variant => {
                let silverSize = variant.options[0].split('-')[1];
                return variant.options[2] === gender && silverSize === size.split('-')[1] && variant.options[1] === weightToTopCover[silverWeight];
            })
            variantID = variant[0].id;

        } else if (element.classList.contains("clogs")) {

            discountProperty = 'clog_upsell';

            // find the variant based on the selected input
            let color = document.querySelector('.upsellSwiperSlideControlsLabelInput:checked').value;
            let clogProduct = JSON.parse(element.dataset.product);

            let clogOptions = [];

            const insoleColorToClogColor = {
                "Black": "Carbon Black",
                "White": "Cloud White",
            }

            // add color, size, gender
            clogOptions.push(insoleColorToClogColor[color]);
            clogOptions.push(gender);

            // map half sizes down to full size
            // 3 -> 3, 3.5 -> 3
            clogOptions.push(parseInt(size).toString());

            // find new variant based on the options
            let clogVariant = clogProduct.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(clogOptions)
            });

            if (clogVariant.available) {
                variantID = clogVariant.id;
            } else {
                available = false;
            }
        } else if (element.classList.contains("grips")) {
            if ((gender === "Male" && isSizeInRange(size, 0, 8)) || (gender === "Female" && isSizeInRange(size, 0, 11))) {
                variantID = 51654863061359 // medium
            } else if ((gender === "Male" && isSizeInRange(size, 0, 12)) || (gender === "Female" && isSizeInRange(size, 0, 13))) {
                variantID = 51654863094127; // large
            } else {
                variantID = 51654863126895; // xlarge
            }
        } else if (element.classList.contains("bag")) {
            discountProperty = 'drawstring_bag_upsell';
            variantID = 51675503427951
        } else if (element.classList.contains("silver")) {
            discountProperty = 'silver_upsell';
            variantID = 51675503427951
        } else {
            // compression socks
            discountProperty = 'compression_socks_upsell';
            if ((gender === "Male" && isSizeInRange(size, 0, 7)) || (gender === "Female" && isSizeInRange(size, 0, 9))) {
                variantID = 42970044924075 // medium
            } else if ((gender === "Male" && isSizeInRange(size, 0, 12)) || (gender === "Female" && isSizeInRange(size, 0, 14))) {
                variantID = 42970045382827; // large
            } else {
                variantID = 42970045415595; // xlarge
            }
        }

        // if this has already been added, remove it from the cart
        if (this.classList.contains("added")) {
            let cart = await getCart();

            // find the item
            let item = cart.items.find(item => item.variant_id === variantID);

            // if there is no item, return
            if (!item) {
                this.textContent = "Add to Cart";
                this.classList.remove("loading");
                return;
            }

            await changeProduct({
                id: item.key,
                quantity: item.quantity - 1
            });

            this.classList.remove("added");
            this.textContent = "Add to Cart";
            this.classList.remove("loading");
            return;
        }


        // add
        if (available) {
            await addProduct({
                quantity: 1,
                id: variantID,
                properties: {
                    _upsell: true,
                    _discount_kit: discountProperty
                }
            });
        }

        // stop loading
        this.classList.remove("loading");

        element.textContent = "Remove";
        this.classList.add("added");


        // if all upsells have been added, close
        if (document.querySelectorAll(".upsellCheckout.added").length === document.querySelectorAll(".upsellCheckout").length) {
            this.closest(".upsell").close();
        }

        // if there is a next slide, slide to it
        if (this.closest(".swiper-slide").nextElementSibling) {
            upsellSwiper.slideNext();
        }
    });
});


// delete the hidden upsells from the DOM
document.querySelector('.hiddenUpsells').remove();

// controls
document.querySelector('.upsellContentControl.prev').addEventListener('click', function () {
    upsellSwiper.slidePrev();
});

document.querySelector('.upsellContentControl.next').addEventListener('click', function () {
    upsellSwiper.slideNext();
});


function isSizeInRange(currentSize, min, max) {
    const range = currentSize.split('-').map(parseFloat);
    const size = parseFloat(range[0]);
    return !isNaN(size) && size >= min && size <= max;
}

// top cover is based of weight (SILVER INSOLES)
let weightToTopCover = {
    "70 - 99lbs": "L",
    "100 - 120lbs": "L",
    "121 - 150lbs": "L",
    "151 - 180lbs": "H",
    "181 - 210lbs": "H",
    "211 - 230lbs": "H",
    "231 - 260lbs": "H",
    "261lbs - Up": "H"
};

function updateUpsell() {
    let silverUpsellEl = document.querySelector('#upsellSilver');


    // map sizes from clog to silver
    let clogSize = parseInt(document.querySelector('.productOptionItemValuesLabelInput.size:checked').value);
    let clogGender = document.querySelector('.productOptionItemValuesLabelInput.gender:checked').value;
    let silverWeight = silverUpsellEl.querySelector('.upsellLabelInput:checked').value;


    let variant = silverProduct.variants.filter(variant => {
        let silverSize = parseInt(variant.options[0].split('-')[1]);
        return variant.options[2] === clogGender && silverSize === clogSize && variant.options[1] === weightToTopCover[silverWeight];
    })

    // no variant found
    if (variant.length === 0) {
        silverUpsellEl.querySelector('.upsellCheckout').disabled = true;
        silverUpsellEl.querySelector('.upsellCheckout').textContent = "Not Available";
        return;
    }
    silverUpsell = variant[0];

    // unavailable variant
    if (!silverUpsell.available) {
        silverUpsellEl.querySelector('.upsellCheckout').disabled = true;
        silverUpsellEl.querySelector('.upsellCheckout').textContent = "Sold Out";
        return;
    }

    silverUpsellEl.querySelector('.upsellCheckout').disabled = false;
    silverUpsellEl.querySelector('.upsellCheckout').textContent = "Add To Cart";
}


// open ankle upsell
async function openUpsell() {

    // update swiper controls
    document.querySelectorAll('.upsellContentControl').forEach(element => element.classList.remove("active"));
    document.querySelector('.upsellSwiperFooter').classList.remove("active");

    document.querySelectorAll('.upsellContentControl').forEach(element => element.classList.add("active"));
    document.querySelector('.upsellSwiperFooter').classList.add("active");


    // remove all swiper slides
    upsellSwiper.removeAllSlides();

    // Add slides
    // check if there are any possible silver variants for the upsell based on their choices for the clogs
    let clogSize = parseInt(document.querySelector('.productOptionItemValuesLabelInput.size:checked').value);
    let clogGender = document.querySelector('.productOptionItemValuesLabelInput.gender:checked').value;
    let possibleSilverVariants = silverProduct.variants.filter(variant => {
        let silverSize = parseInt(variant.options[0].split('-')[1]);
        return variant.options[2] === clogGender && silverSize === clogSize;
    })
    if (possibleSilverVariants.length > 0) {
        // add silver slide if there are any possible silver variants
        upsellSwiper.appendSlide(silverSlide);

        // listen for silver upsell input change (weight)
        document.querySelectorAll('.upsellLabelInput')?.forEach(element => {
            element.addEventListener("change", function () {
                updateUpsell();
            });
        })
    }
    upsellSwiper.appendSlide(socksSlide);
    upsellSwiper.appendSlide(bagSlide);


    // open the upsell
    document.querySelector(`#upsell`).showModal();

    document.querySelector("body").classList.add("noScroll");


    // wait for modal to be closed
    await new Promise((resolve, reject) => {
        document.querySelector(`#upsell`).addEventListener("close", function (e) {
            resolve('closed');
        });
    });
}

// close events
document.querySelectorAll(".upsell").forEach(element => {
    // exist backdrop
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
            document.querySelector("body").classList.remove("noScroll");

        }
    })
});

// close upsell via button
document.querySelectorAll(".upsellClose").forEach(element => {
    element.addEventListener("click", function () {
        this.closest(".upsell").close();
        document.querySelector("body").classList.remove("noScroll");
    });
});


// register dialog
dialogPolyfill.registerDialog(document.querySelector("#upsell"));


/**************
 Shoe size
 ***************/

// open shoe size modal
document.querySelectorAll(".openShoeSize").forEach(element => {
    element.addEventListener("click", function () {
        document.querySelector('#shoeSizeClog').showModal();
        document.querySelector("body").classList.add("noScroll");
    })
});

//close shoe size event listener
document.querySelectorAll(".shoeSizeContentClose")?.forEach(function (element) {
    element.addEventListener("click", async function () {
        let target = this.dataset.target;
        await closeSize(target);
        // open back up modal once the shoe size modal is closed
        if (lastOpenedModal) {
            lastOpenedModal.showModal();
        }
        preventSubmit = false;

    });
});


//close shoe size event listener
document.querySelectorAll(".shoeSize")?.forEach(function (element) {
    element.addEventListener("click", async function (e) {
        if (e.target === this) {
            let target = element.id;
            await closeSize(target);

            // open back up modal once the shoe size modal is closed
            if (lastOpenedModal) {
                lastOpenedModal.showModal();
            }

            preventSubmit = false;
        }
    });
});

// close shoe size
function closeSize(target) {
    document.querySelector(`#${target}`).close();
    document.querySelector("body").classList.remove("noScroll");
}

// register dialogs
// wait for document to load first
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("dialog.shoeSize")?.forEach(function (element) {
        dialogPolyfill.registerDialog(element);
    });
});

/**************
 Money Back
 ***************/

// open moneyBack dialog
document.querySelectorAll('.openMoneyBack').forEach(function (element) {
    element.addEventListener('click', function () {
        document.querySelector("#moneyBack").showModal();
        document.querySelector("body").classList.add("noScroll");
    });
})

// close moneyBack
function closePopup() {
    document.querySelector("#moneyBack").close();
    document.querySelector("body").classList.remove("noScroll");
}

// close moneyBack event listener
document.querySelectorAll(".moneyBackClose").forEach(function (element) {
    element.addEventListener("click", closePopup);
});

document.querySelector("#moneyBack").addEventListener("click", function (e) {
    if (e.target === this) {
        closePopup();
    }
})

// close event
document.querySelector("#moneyBack").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#moneyBack"));
